// eslint-disable-next-line
Date.prototype.addDays = function addDays(days) {
  const dat = new Date(this.valueOf());
  dat.setDate(dat.getDate() + days);
  return dat;
};

function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

function gestionCalage(date, jour) {
  let dateEcheance = date;
  let jourCalage = jour;
  dateEcheance = dateEcheance.addDays(1);
  jourCalage -= 1;
  if (dateEcheance.addDays(jourCalage).getMonth() !== dateEcheance.getMonth()) {
    const nJours = daysInMonth(dateEcheance.getMonth() + 1, dateEcheance.getFullYear());
    dateEcheance = dateEcheance.addDays(nJours - dateEcheance.getDate());
  } else dateEcheance = dateEcheance.addDays(jourCalage);
  return dateEcheance;
}

function gestionFinMois(date, jourCalage) {
  let dateEcheance = date;
  const nJours = daysInMonth(dateEcheance.getMonth() + 1, dateEcheance.getFullYear());
  dateEcheance = dateEcheance.addDays(nJours - dateEcheance.getDate());
  if (jourCalage > 0) dateEcheance = gestionCalage(dateEcheance, jourCalage);
  return dateEcheance;
}

export default function calculDateEcheancier(dateFacture, detailDelaiReglement) {
  const delaiReglement = detailDelaiReglement;
  let dateEcheance = dateFacture;
  if (delaiReglement !== null) {
    dateEcheance = dateEcheance.addDays(Number(delaiReglement.nombreJourDecalage));
    if (delaiReglement.finDeMois === true) {
      dateEcheance = gestionFinMois(dateEcheance, delaiReglement.jourFinDeMois);
    }
  }
  return dateEcheance;
}
